import { getDayAndMonthFromDate } from '@/src/utils/dateUtils'

type DateIndicatorProps = {
  diagnosisDate: Date
  actionPlanDate?: Date
}

const DateIndicator = ({ diagnosisDate, actionPlanDate }: DateIndicatorProps) => {
  return (
    <div className="flex flex-col gap-2 items-center py-1 w-full">
      <div className="flex items-center w-full px-3">
        <div className="h-4 w-4 border-[1px] border-white rounded-full"></div>

        {actionPlanDate && (
          <>
            <div className="flex-1 h-[2px] bg-white mx-1"></div>
            <div className="h-4 w-4 bg-white rounded-full"></div>
          </>
        )}
      </div>

      <div className="flex justify-between w-full text-white">
        <span>{getDayAndMonthFromDate(diagnosisDate)}</span>
        {actionPlanDate && <span>{getDayAndMonthFromDate(actionPlanDate)}</span>}
      </div>
    </div>
  )
}

export default DateIndicator
